export default __webpack_public_path__ + "static/media/LynkcoType-Medium.85b69171.ttf";